import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const TemplateDetailsRaw = React.lazy(() => import(/* webpackChunkName: "ClientAppearanceDetails" */ './TemplateDetails'));
export const TemplateDetailsForAppearance = () => (React.createElement(Page, { title: "Template", description: "Template" },
    React.createElement(Main, { sidebar: true },
        React.createElement("div", { className: "container-fluid att-main no-pad-r" },
            React.createElement("div", { className: "no-pad attorney-wrap " },
                React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
                    React.createElement(TemplateDetailsRaw, null)))))));
